import {
    Button, Modal, Form, Switch, Input, App, Row
  } from 'antd';
import {
    CheckOutlined, CloseOutlined,  WarningOutlined,  
  } from '@ant-design/icons';
import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { ViewNextServiceDetail } from './SummaryTabbedCanvas';
import FieldSet from '../../components/panels/Fieldset';
import { ViewTestHint } from './SummaryTabbedCanvas';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";



const ReviewAncillaryBookingRequest = ( {vehicle, isViewAncillaryRequestModalVisible, setIsViewAncillaryRequestModalVisible, form, 
                                         currentRequest, setCurrentRequest} ) => {

    const { t } = useTranslation();
    const { isOnline } = useOnlineStatus();
    const { TextArea } = Input;
    const { notification } = App.useApp();
    const [ loadingProgress ] = useState(0);  //start 0 - button shows loading if less than 100
    const ancillary = currentRequest?.popupAncillary;
    const isEligibleForRecall = ancillary ? ancillary?.hasActiveRecall : false;
    const isRegulatoryTestExpiredOrDuetoExpire = ancillary ? ancillary?.hasRegulatoryTestExpiredOrDuetoExpire : false;
    const testExpiryDate = ancillary?.testExpiryDate;
    const nextService = ancillary?.nextScheduledEvent;
    const currentAncillaryRequest = currentRequest?.ancillaries?.find(anc => anc.ancillaryVehicleId === ancillary?.id);


    // is used to repopulate the modal if driver decided to edit the ancillaries booking request
    useEffect(() => {
        form.resetFields();
        // const currentAncillaryRequest = currentRequest?.ancillaries?.find(anc => anc.ancillaryVehicleId === ancillary?.id);

        if (currentAncillaryRequest){
           form.setFieldsValue({regulatoryTestRequired: currentAncillaryRequest?.regulatoryTestRequired});
           form.setFieldsValue({serviceRequired: currentAncillaryRequest?.serviceRequired});
           form.setFieldsValue({recallRequired: currentAncillaryRequest?.recallRequired});
           form.setFieldsValue({workRequired: currentAncillaryRequest?.workRequired});
        } 
      }, [form, ancillary?.id, currentRequest?.ancillaries, currentAncillaryRequest]);

    
      const onFinish = (values) => {

        let hasRepairRequirements = values != null ? (isRegulatoryTestExpiredOrDuetoExpire && values.regulatoryTestRequired) || 
                                                    (isEligibleForRecall && values.recallRequired) ||
                                                    values.serviceRequired || values.workRequired != null : true;

        notification.destroy();

        if (!hasRepairRequirements){
            notification.open({
                icon: <WarningOutlined style={{color: 'var(--dp-status-colour-warning)'}}/>,
                description: t('message.missing_repair_options', {0: t('value.test')}),
                duration: null,
                });        
        }

        if (hasRepairRequirements){
            const newBookingRequest = {
                ...values,
                ancillaryVehicleId: ancillary?.id,
                isRegulatoryTestRequired: values.regulatoryTestRequired,
                isServiceRequired: values.serviceRequired,
                isRecallRequired: values.recallRequired,                
            }

            if (currentRequest){
                if (currentRequest.hasOwnProperty('ancillaries')){
                    let currentAncillary = currentRequest.ancillaries.find(anc => anc.ancillaryVehicleId === newBookingRequest.ancillaryVehicleId);
                    const indexOfExistingAncillary = currentRequest.ancillaries.indexOf(currentAncillary);
                    
                    // if an ancillary request exists and the driver updates it, then that old request will be removed and replaced with the latest updates;
                    // hence a new request will always be pushed into currentRequest.ancillaries 
                    if (currentAncillary && !(indexOfExistingAncillary < 0)){
                        currentRequest.ancillaries.splice(indexOfExistingAncillary, 1)
                    } 
                    currentRequest.ancillaries.push(newBookingRequest);
                } else {
                    currentRequest.ancillaries = [];
                    currentRequest.ancillaries.push(newBookingRequest);
                }
            }
            
            setIsViewAncillaryRequestModalVisible(false); 
        }
      }

      const onFinishFailed = (errorInfo) => {
        console.log('Form Failed:', errorInfo);
      };

      const removeBookingRequest = (current) => {
        const indexOfCurrentAncillary = currentRequest.ancillaries.indexOf(current);
        if (!(indexOfCurrentAncillary < 0)){
            currentRequest.ancillaries.splice(indexOfCurrentAncillary, 1)
        }
        setIsViewAncillaryRequestModalVisible(false); 
      }

    return (
        <Modal className="std-portal-popup dp-wrap-card-title" 
               open={isViewAncillaryRequestModalVisible}
               title={ ancillary ? ancillary?.descriptionPlusSerialNo : "" }
               closable={true}
               keyboard={true}
               footer={
                 isOnline
                 ?
                 [
                  <Button key="cancel" 
                          onClick={(e) => {
                            setIsViewAncillaryRequestModalVisible(false); 
                            notification.destroy();
                            form.resetFields();
                          }}
                  >
                    {t('action.cancel')}
                  </Button>,
                  !currentAncillaryRequest
                  ? 
                  <></> 
                  :
                  <Button key="remove" 
                          type="primary" 
                          danger 
                          onClick={() => removeBookingRequest(currentAncillaryRequest)}>
                    {t('action.remove')}
                  </Button>,
                  <Button type="primary" 
                          form="editAncillaryRequest"
                          loading={loadingProgress !== 100 && !vehicle} 
                          key="submit"
                          htmlType="submit"
                  >
                    {t('action.save')}
                  </Button>
                ]
                :
                <></>
               }
               onCancel={() => {
                setIsViewAncillaryRequestModalVisible(false);
               }}
        >
            {
             testExpiryDate 
             ? 
             <FieldSet items={[{key: '1',
                                label: t('field.test_expiry_date'),
                                value: testExpiryDate,
                       }]}
            />
             : 
             <></>
             }
            <Form form={form} 
                  layout="vertical"
                  name="editAncillaryRequest" 
                  style={{"width": "100%"}} 
                  onFinish={onFinish}  
                  onFinishFailed={onFinishFailed}
            >
              {
                isRegulatoryTestExpiredOrDuetoExpire
                ?
                <Form.Item name="regulatoryTestRequired" 
                           label={t('field.regulatory_test_required')}
                           layout='horizontal'
                           style={{ marginTop: '10px', marginBottom: '15px' }}
                           valuePropName="checked" 
                >
                  <Switch checkedChildren={ <CheckOutlined/> }
                            unCheckedChildren={ <CloseOutlined/> }
                            disabled={ !isRegulatoryTestExpiredOrDuetoExpire }
                    />
                </Form.Item>
                :
                <Form.Item name="regulatoryTestRequired" 
                           label={t('field.regulatory_test_required')}
                           layout='horizontal'
                           style={{ marginTop: '10px', marginBottom: '15px' }}
                           valuePropName="checked" 
                >
                <Row align="middle" style={{ marginTop: '-5px' }}>
                  <Switch checkedChildren={ <CheckOutlined/> }
                            unCheckedChildren={ <CloseOutlined/> }
                            disabled={ !isRegulatoryTestExpiredOrDuetoExpire }
                    />
                    <ViewTestHint message={ t('message.test_not_allowed')} isEligibleForTest={isRegulatoryTestExpiredOrDuetoExpire}/>
                </Row>
                </Form.Item>
              }
              <ViewNextServiceDetail nextService={nextService ? nextService : undefined}></ViewNextServiceDetail>
              <Form.Item name="serviceRequired" 
                          label={ t('field.service_required') }
                          layout='horizontal'
                          valuePropName="checked" 
              >
                  <Switch checkedChildren={ <CheckOutlined/> }
                          unCheckedChildren={ <CloseOutlined/> }/>
              </Form.Item> 
              <Form.Item name="recallRequired" 
                          label={t('field.recall_required')}
                          layout='horizontal'
                          valuePropName="checked" 
                          hidden={ !isEligibleForRecall }
              >
                  <Switch disabled={ !isEligibleForRecall }
                          checkedChildren={ <CheckOutlined/> }
                          unCheckedChildren={ <CloseOutlined/> }
                  />
              </Form.Item> 
              <Form.Item name="workRequired" 
                          label={t('field.work_required')}
              >
                  <TextArea placeholder={t('action.enter_value')}
                            rows={4}
                            maxLength={500}
                            showCount
                            style={{ marginBottom: '10px' }}
                  />
              </Form.Item>                
          </Form>
        </Modal>
    );
}

export default ReviewAncillaryBookingRequest;